import React from 'react';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import {
  ButtonsContainer,
  HeroVideoContainer,
  HeroVideoWrapper,
  HeroVideoOverlay,
  RegistryHeroTextColumn,
  StyledSection,
  StyledButton,
  StyledGetStartedButton,
} from '@sections/baby-registry/HeroSection/HeroSection.styles';
import { babyRegistryPageData } from '@data-ts/pages/baby-registry';
import { getRootUrl } from '@utils/urlHelpers.util';
import { VimeoVideo } from '@components/VimeoVideo';
import { ValuePropsSection } from '@components/ValuePropsSection';
import { PropsSlider } from './Components/PropsSlider/PropsSlider';
import { BABY_REGISTRY } from 'src/pages/baby-registry';
import { BABY_REGISTRY_VALUE_PROPS, HERO_VIDEO_URL, VALUE_PROPS_ELEMENT_ID } from './HeroSection.constants';

export const HeroSection = () => {
  return (
    <>
      <StyledSection as="section" id="Baby_Registry_Hero">
        <HeroVideoContainer>
          <HeroVideoWrapper>
            <HeroVideoOverlay />
            <VimeoVideo
              posterUrl="/baby-registry/hero-video/joybaby_headervideo_v12_posterframe_000.jpg"
              isEagerLoading
              embedUrl={HERO_VIDEO_URL}
              title={babyRegistryPageData.hero.title}
              autoPlay
              background
              controls={false}
              autoPause={false}
              alt="baby-registry-hero"
              muted
              loop
              cover
              posterOptimization="aggressive"
            />
          </HeroVideoWrapper>
        </HeroVideoContainer>
        <RegistryHeroTextColumn verticalAlign="center">
          <Columns.Column width={12}>
            <Flex flexDirection={'column'} paddingLeft={[4, 12]}>
              <PropsSlider />
              <ButtonsContainer>
                <StyledGetStartedButton id="babyRegistryHeroGetStartedBtn" variant="secondary" page={BABY_REGISTRY}>
                  {babyRegistryPageData.hero.getStarted}
                </StyledGetStartedButton>
                <StyledButton id="babyRegistryHeroFindCoupledBtn" variant="darkfindACoupleBtn" forwardedAs={'a'} href={getRootUrl('/find')}>
                  {babyRegistryPageData.hero.findARegistry}
                </StyledButton>
              </ButtonsContainer>
            </Flex>
          </Columns.Column>
        </RegistryHeroTextColumn>
      </StyledSection>
      <ValuePropsSection values={BABY_REGISTRY_VALUE_PROPS} elementId={VALUE_PROPS_ELEMENT_ID} />
    </>
  );
};
